import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)

require('./theme/app.scss')
require('bootstrap-vue/dist/bootstrap-vue.css')

Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  store,
  render: h => h(App),
  template: '<App/>'
}).$mount('#app')
